/*
 * View for generic folder navigation tree.  Use the recursive nature of
 * CompositeViews to handle tree structure
 */

define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "modules/shared/navTree/template/navTreeTemplate.html",
], function (Marionette, _, Messenger, NavTreeTemplate) {
  "use strict";

  const NavTreeView = {};

  // noinspection JSUnusedGlobalSymbols
  NavTreeView.navTreeView = Marionette.CompositeView.extend({
    className: "nav-tree",
    template: NavTreeTemplate,
    initialize: function (options) {
      //pass name attribute in
      this.nameAttr = options.name;
      this.namespace = options.namespace;
      this.setUpVents();
    },
    itemViewOptions: function () {
      //pass name attribute to the collection's children
      return {
        name: this.nameAttr,
        namespace: this.namespace,
      };
    },
    itemViewContainer: ".children",
    itemViewEventPrefix: "", //do not differentiate between events from the collection views
    modelEvents: {
      sync: "render",
      change: "toggleView",
      enter: "render",
      expand: "expand",
      toggle: "toggleExpandCollapse",
      select: "select",
      clearSelect: "clearSelect",
      showSelect: "showSelect",
    },
    events: {
      "click .toggle-expand-collapse": "toggleExpandCollapse",
      "click .hide": "collapse",
      "click .group": "select",
    },
    toggleExpandCollapse: function () {
      if (!this.model.expanded) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    expand: function () {
      console.log("expand " + this.model.get(this.nameAttr));
      this.model.expanded = true;
      //if the collection is being added for the first time, make sure to render the children
      const needToRenderChildren = !this.collection;
      this.collection = this.model.subGroups();
      this.stopListening(this.collection);
      this._initialEvents(); //connect collection events to the view
      this.listenTo(this.collection, "sort", function () {
        this._renderChildren();
      });
      if (this.collection.checkFetching()) {
        this._toggleSpinner();
      } else {
        if (needToRenderChildren) {
          this._renderChildren();
        }
        this.$el.children(".children").show();
        this._toggleCollapse();
      }
      if (typeof this.model.isRoot === "function" && this.model.isRoot()) {
        // this trigger is only used with root group model
        this.model.trigger("folder:expanded");
      }
    },
    collapse: function () {
      if (this.model.expanded) {
        console.log("collapse " + this.model.get(this.nameAttr));
        this.model.expanded = false;
        this._toggleExpand();
        this.$el.children(".children").hide();
        if (typeof this.model.isRoot === "function" && this.model.isRoot()) {
          // this trigger is only used with root group model
          this.model.trigger("folder:collapsed");
        }
      }
    },
    serializeData: function () {
      const data = this.constructor.__super__.serializeData.apply(this, arguments);
      if (this.nameAttr != "name") {
        data.name = data[this.nameAttr];
      }
      return data;
    },
    select: function () {
      //we need to use the vent and not the view because the view could be many layers deep in the tree
      //console.log("selected " + this.model.get(this.nameAttr));
      Messenger.vent.trigger("_" + Messenger.getFullName("select:group", this.namespace), this);
      return false;
    },
    clearSelect: function () {
      this.model.selected = false;
      this.toggleSelect();
    },
    showSelect: function () {
      this.model.selected = true;
      this.toggleSelect();
    },
    onRender: function () {
      this.toggleView();
    },
    setUpVents: function () {
      Messenger.vent.on(
        "_" + Messenger.getFullName("clear:selection", this.namespace),
        this.clearSelect,
        this,
      );
    },
    _toggleExpand: function () {
      this.$el.children(".toggle").html('<i class="icon-plus-sign toggle-expand-collapse"></i>');
    },
    _toggleCollapse: function () {
      this.$el.children(".toggle").html('<i class="icon-minus-sign toggle-expand-collapse"></i>');
    },
    _toggleSpinner: function () {
      this.$el.children(".toggle").html('<i class="icon-spinner icon-spin"></i>');
    },
    toggleSelect: function () {
      if (this.model.selected) {
        this.$el.find(".folder").first().addClass("icon-folder-open");
        this.$el.find(".folder").first().removeClass("icon-folder-close");
        this.$el.find(".name").first().addClass("bold");
      } else {
        this.$el.find(".folder").first().removeClass("icon-folder-open");
        this.$el.find(".folder").first().addClass("icon-folder-close");
        this.$el.find(".name").first().removeClass("bold");
      }
    },
    toggleView: function () {
      if (this.model.selected) {
        this.toggleSelect();
      }
      if (this.model.get("hasSubgroups")) {
        if (this.model.expanded) {
          this._toggleCollapse();
        } else {
          this._toggleExpand();
        }
      } else {
        this.$el.children(".toggle").html("");
      }
    },
  });

  return NavTreeView;
});
